import { render, staticRenderFns } from "./props-table-cell-header.vue?vue&type=template&id=59dfe82e&"
import script from "./props-table-cell-header.vue?vue&type=script&lang=ts&"
export * from "./props-table-cell-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports